module.exports = __webpack_public_path__ + "static/img/logo_cover.795ce66.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_cover.png
// module id = ujTF
// module chunks = 1